import React from 'react';
import { HiverAxios, showMessage } from 'h-commons';
import { 
    SETUP_CONNECTOR_DONE,
    SETUP_CONNECTOR_FAILED,
    SETUP_CONNECTOR_INIT,
    typePrefixMap,
    getConnectorChannels
} from './index';
const SLACK_AUTH_STATUS = 'slack_auth_status';
const SLACK_ERROR_MSG = 'slack_error_msg';
/**
 * used to initialize popup for slack connector it continuously monitors the state of the popup window 
 * and resolves by calling callback method with success/faliure in setup process
 * @param  {string} url        authorization url to open in popup window
 * @param  {function} callback callback function after popup window operation finishes
 */
const connectorPopup = (popup, url, callback) => {
    localStorage.removeItem(SLACK_AUTH_STATUS);
    localStorage.removeItem(SLACK_ERROR_MSG);
    popup.location.href = url;

    const handleMessage = (event) => {
        if (event.data.type === "slackAuthMessage") {
            localStorage.setItem('slack_auth_status', event.data.authStatus);
            localStorage.setItem('slack_error_msg', event.data.errorMessage);
            window.removeEventListener('message', handleMessage);
            popup.close();
        }
    };

    window.addEventListener('message', handleMessage);
    const finishedInterval = setInterval(function() {
        const auth_status = localStorage.getItem(SLACK_AUTH_STATUS);
        if(auth_status && auth_status !== "undefined") {
            clearInterval(finishedInterval);
            if(auth_status === 'succeeded' && typeof callback === 'function'){
                callback(true);
            }
            else{
                var error_msg = localStorage.getItem(SLACK_ERROR_MSG);
                if(!error_msg || error_msg.length === 0) {
                    error_msg = 'Error while authorising Hiver for Slack. Please try again later';
                }
                callback(false, error_msg);
            }
        } else if(popup && popup.closed) {
            clearInterval(finishedInterval);
            callback(false, 'App authorization was cancelled/failed.');
        }
    });
}

const renderErrorMessage = (error) => {
    return (
        <div className='h-sm-create-instruction'>
            <div className='h-mt-13p'>
                Connector setup failed. Please try again.
                {error}
            </div>
            <div className='h-mb-6p'>
                If the problem persists, contact us at support@hiverhq.com
            </div>
        </div>
    )
}
/**
 * redux async action to intitalize setup of connector 
 * @param  {string} type         Connector Type
 * @param  {string|number} smid  Shared Mailbox Id  
 */
export const setupConnnector = (type, smid, popup, isTest) => dispatch => {
    if (!(type in typePrefixMap)) {
        dispatch({
            type: SETUP_CONNECTOR_FAILED,
            error: 'Unsupported Connector'
        })
        return;
    }
    dispatch({
        type: SETUP_CONNECTOR_INIT
    });
    const prefix = typePrefixMap[type];
    const reqtObj ={
        smid:smid
    };
    return HiverAxios({
        url: `${prefix}/setup`,
        type: 'POST',
        params: reqtObj,
        callback: resp => {
            const { url, is_authorised } = resp.data;
            if (is_authorised){
                dispatch({
                    type: SETUP_CONNECTOR_DONE,
                    payload: { is_authorised, shouldExpand: true, smid, type }
                });
                dispatch(getConnectorChannels(type, smid));
                showMessage({
                    message:'Please save connector settings to enable.',
                    type:'info'
                });
                popup.close();
            } else if (!is_authorised && url) {
                connectorPopup(popup, url, (success, error) => {
                    if (success) {
                        dispatch({
                            type: SETUP_CONNECTOR_DONE,
                            payload: { is_authorised: !is_authorised, shouldExpand: true, smid, type }
                        });
                        showMessage({
                            message:'Connector setup done. Please save settings to enable.',
                            type:'success'
                        });
                        dispatch(getConnectorChannels(type, smid));
                    }
                    else {
                        showMessage({
                            message: renderErrorMessage(error),
                            type:'error'
                        });
                        dispatch({
                            type: SETUP_CONNECTOR_FAILED,
                            error: 'App authorization was cancelled/failed.'
                        });
                    }
                });
            }
        },
        onfail: err => {
            dispatch({
                type: SETUP_CONNECTOR_FAILED,
                error: err
            });
            showMessage({
                message: renderErrorMessage(),
                type:'error'
            });
        }
    }, isTest);
}
